export default "__VITE_ASSET__BtA48KYG__"